class GasClubHeader {
  constructor(header) {
    this.header = header;
    this.button = header.querySelector('.mobile-toggle');
    this.nav = header.querySelector('.site-nav');
    if (!this.button || !this.nav) return;
    this.button.addEventListener('click', () => this.toggle());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  toggle() {
    const open = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', String(!open));
    this.nav.classList.toggle('is-open', !open);
  }

  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.nav.classList.remove('is-open');
  }
}

class GasClubMotion {
  constructor(root = document) {
    this.items = [...root.querySelectorAll('.reveal-on-scroll:not([data-motion-ready])')];
    if (!this.items.length) return;
    this.items.forEach((item) => item.dataset.motionReady = 'true');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    this.items.forEach((item) => this.observer.observe(item));
  }
}

const initializeGasClub = (root = document) => {
  root.querySelectorAll('.site-header:not([data-header-ready])').forEach((header) => {
    header.dataset.headerReady = 'true';
    new GasClubHeader(header);
  });
  new GasClubMotion(root);
};

initializeGasClub();
document.addEventListener('shopify:section:load', (event) => initializeGasClub(event.target));

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || window.Shopify?.designMode) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((result) => result.json());
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = cart.item_count;
    });
    button.textContent = 'Added';
  } catch (error) {
    button.textContent = 'Try again';
  } finally {
    window.setTimeout(() => {
      button.textContent = original;
      button.disabled = false;
    }, 1500);
  }
});